import React from 'react';
import { MetaTags } from 'react-meta-tags';
import { Container } from 'reactstrap';
import AdvancePostingList from '../components/AdvancePostingList';
import { Toaster } from 'react-hot-toast';

const AdvancePostingListIndex = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Advance Posting List</title>
        </MetaTags>
        <Container fluid>
          <AdvancePostingList />
        </Container>
      </div>

      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};
export default AdvancePostingListIndex;
